export default __webpack_public_path__ + "static/media/0x0e50bea95fe001a370a4f1c220c49aedcb982dec.1ebd5ab5.webp";